import { initialFamilyGroupManagementModel } from "../Models/FamilyGroupManagementModel";
import { initialValueOfFamilyGroupModel } from "../Models/FamilyGroupModel";
import { initialValueOfSearchFamilyGoup } from "../Models/SearchFamilyGoupModal";
import { initialValueOfProductModel } from "../Models/ProductModel";
import { ValuesType } from "../Types/InitialStateType";
import { formDataFilterFormatterAsPerModel, formDataFilterFormatterWithoutModel } from "./formDataFilterFormatter";
import * as Constants from '../Constants/index'
import { initialValueOfDuTypeModel } from "../Models/DuTypeManagementModel";
import { initialValueOfDimensionModel } from "../Models/DimensionModel";

export const filterModelSelecterAndProcessData = (values: ValuesType[], modelName: string): string => {
  let response = ""
  switch (modelName) {
    case Constants.FilterCaseConstants.FamilySummary:
      response = formDataFilterFormatterAsPerModel(values, initialValueOfFamilyGroupModel)
      break;
    case Constants.FilterCaseConstants.FamilyManagement:
      response = formDataFilterFormatterAsPerModel(values, initialFamilyGroupManagementModel)
      break;
    case Constants.FilterCaseConstants.FamilyQuery:
    case Constants.FilterCaseConstants.ProductQuery:
    case Constants.FilterCaseConstants.ProductAttributes:
    case Constants.FilterCaseConstants.ProductMeasurementsClothing:
    case Constants.FilterCaseConstants.ProductHierarchy:
    case Constants.FilterCaseConstants.ProductMeasurements:
      //response = isDirectQuery ? formDataFilterFormatterWithoutModel(values) : formDataFilterFormatterAsPerModel(values, initialValueOfProductModel)
      response = formDataFilterFormatterWithoutModel(values)
      break;
    case Constants.FilterCaseConstants.SearchFamilyGoup:
      response = formDataFilterFormatterAsPerModel(values, initialValueOfSearchFamilyGoup)
      break;
    case Constants.FilterCaseConstants.DuTypeManagement:
      response = formDataFilterFormatterAsPerModel(values, initialValueOfDuTypeModel)
      break;
    default:
      break;
  }
  return response
}